import { APIRoute } from '@/modules/utils'
import { SendTokenStatus } from '@/modules/Stripe/apiTypes/base'

export const Route: APIRoute = {
  method: 'POST',
  path: '/v2/stripe/subscriptions',
}

export type Body = {
  paymentMethodId?: string
  customer?: string
  plan: string
  coupon: string
}

export type Response = {
  id: string
  object: 'payment_intent' | 'setup_intent'
  customer: string
  clientSecret: string
  status: SendTokenStatus
}
